module.exports = __webpack_public_path__ + "static/media/Phone.3efcae89.png";